import styles from './copy-course-dialog.module.scss';
import { useCourseGetRequestHook } from '../../../requestUtils';
import { ICourse } from '../../../_models/course';
import BaseCourseDialog from '../../../base-course-dialog/base-course-dialog';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CopyCourseDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  courseId: string
}

export function CopyCourseDialog(props: CopyCourseDialogProps) {
  const { data: course }: { data: ICourse } = useCourseGetRequestHook(`course/get/${props.courseId}`, undefined);
  const { t } = useTranslation();

  if (!course) return null;
  course.id = undefined;

  return <BaseCourseDialog
    course={course}
    onClose={props.onClose}
    open={props.open}
    refreshData={props.refreshData}
    handleOkText={t("standard.addCourse")}
    headerText={`${t("standard.addCourse")} <small style="color: #666;">(${t("standard.copy")})</small>`}
  />
}

export default CopyCourseDialog;
